import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LoginService } from '../service/login.service'
import { UserService } from '../service/user.service';
import { MenuService } from '../../app/service/menu.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  loginusername: string = '';
  loginpassword: string = '';
  loginError: boolean = false;

  constructor(
    private router: Router,
    private loginService: LoginService,
    private userService: UserService,
    private menuService: MenuService) { }

  ngOnInit(): void {
    sessionStorage.clear();
    localStorage.clear();
  }

  onSidebarLinkClick(linkName: string) {
    this.menuService.setSelectedMenu(linkName);
  }

  onSubmit(form: any) {
    this.userService.clearUserData();
    if (form.valid) {
      this.loginService.validateUser(this.loginusername, this.loginpassword).subscribe({
        next: (response) => {
          if (response.status === 200) {
            const data = response.body;
            this.userService.setUserId(data.id);
            this.userService.setRole(data.role);
            this.userService.setRoleId(data.roleId);
            this.userService.setFirstName(data.firstName);
            this.userService.setLastName(data.lastName);
            this.userService.setCustomerId(data.customerID);
            this.userService.setCustomerName(data.customerName);
            this.userService.setAccessToken(data.token);
            this.handleRoleRedirection(data.role);
          } else {
            this.loginError = true;
          }
        },
        error: (err) => {
          this.loginError = true;
        }
      });
    }
  }

  private handleRoleRedirection(role: string): void {
    switch (role) {
      case 'VCCAD':
        this.onSidebarLinkClick('My Masters');
        this.router.navigate(['/ActMaster']);
        break;

      case 'VCCON':
      case 'VCAUD':
        this.onSidebarLinkClick('My Workspace');
        this.router.navigate(['/ContractorWorkspace']);
        break;
          
      case 'SPCON':
      case 'SPAUD':
      case 'SPSAD':
        this.router.navigate(['/CustomerDashboard']);
        break;

      case 'VCMNG':
      case 'VCPH':
      case 'VCPD':
        this.router.navigate(['/Dashboard']);
        break;
        
        case 'SPADM':
           this.onSidebarLinkClick('Customer');
          this.router.navigate(['/CustomerMaster']);
          break;

      default:
        this.onSidebarLinkClick('My Masters');
        this.router.navigate(['/ActMaster']);
        break;
    }
  }
}